import Axios from 'axios';

const BANEADOS = '/Banned/GetBaneados/0'
const SET_BANEADO = '/Banned/SetBaneados'
const REMOVE_BANEADO = '/Banned/RemoveBaneados'
const TIPOS = '/Banned/GetTipos'
const COMPARADORES = '/Banned/GetComparacion'

export default {
  baneados: {
    getAll() {
      return Axios.get(BANEADOS)
    },
    set(payload) {
      return Axios.post(SET_BANEADO, payload)
    },
    remove(payload) {
      return Axios({
        method: 'delete',
        url: REMOVE_BANEADO,
        data: payload
      });
    }
  },
  tipos: {
    getAll() {
      return Axios.get(TIPOS)
    },
    set(payload) {
      return Axios.post(TIPOS, payload)
    }
  },
  comparadores: {
    getAll() {
      return Axios.get(COMPARADORES)
    },
    set(payload) {
      return Axios.post(COMPARADORES, payload)
    }
  }
};